import register from '../../../../global/js/registry';
export default register('m-formstep-personal-data', () => import(/* webpackMode: "lazy" */ './m-formstep-personal-data.controller'));
